/* ============================================================
   dr.GUT — Aviso do cupom no lugar certo

   O tema respondia ao cupom com o toast global (assets/global.js →
   showToast): um retângulo `position: fixed` no canto superior direito
   da tela, a 3rem do topo. Por cima do drawer, longe do campo que a
   pessoa acabou de usar, ele parecia solto na tela.

   Aqui a resposta passa a nascer colada ao campo, logo abaixo do
   input — quem leu o texto está olhando para o lugar onde ele aparece.

   Como: os métodos `toastSuccess` e `toastError` do <minicart-discount>
   (assets/cart-discount.js) são públicos, então basta trocá-los no
   protótipo. O arquivo do tema fica intocado e continua ditando QUANDO
   avisar e COM QUAL texto (cartStrings, vindo dos locales); daqui sai
   só o ONDE.

   Por que um asset carregado no theme.liquid e não um <script> dentro
   do snippet do cupom: o drawer é re-renderizado trocando o innerHTML
   de #minicart-form, e script inserido por innerHTML não executa. Com
   o carrinho vazio o snippet do cupom nem existe na primeira carga —
   ele só entra nessa re-renderização. Daqui a troca é feita uma vez,
   antes de qualquer clique, e vale para todas as vezes seguintes.
   ============================================================ */
(function () {
  'use strict';

  var SUMIR_APOS = 6000;

  var ICONE_OK =
    '<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/>' +
    '<circle cx="9" cy="9" r="7.5"/>';
  var ICONE_ERRO =
    '<circle cx="9" cy="9" r="7.5"/><path d="M9 5.4v4.2M9 12.4h.01"/>';

  /* Qual <minicart-discount> deve receber o aviso.

     No sucesso o tema re-renderiza #minicart-form inteiro antes de
     avisar, e o elemento que pediu a mensagem já saiu do DOM — quem
     está na tela é o substituto. No erro não há re-renderização e o
     próprio elemento serve. A página /cart e o drawer podem coexistir,
     daí a preferência por um que esteja de fato visível. */
  function alvo(elemento) {
    if (elemento && elemento.isConnected) return elemento;

    var todos = document.querySelectorAll('minicart-discount');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].offsetParent !== null) return todos[i];
    }
    return todos[todos.length - 1] || null;
  }

  function mostrar(elemento, texto, tipo) {
    var raiz = alvo(elemento);
    if (!raiz || !texto) return;

    var caixa = raiz.querySelector('.drgut-coupon__msg');
    if (!caixa) {
      caixa = document.createElement('p');
      caixa.className = 'drgut-coupon__msg';
      /* role="status" faz o leitor de tela anunciar o texto sem roubar
         o foco de quem está no campo. */
      caixa.setAttribute('role', 'status');

      /* Logo abaixo do form, acima da lista de cupons aplicados. */
      var form = raiz.querySelector('form');
      if (form && form.nextSibling) {
        raiz.insertBefore(caixa, form.nextSibling);
      } else {
        raiz.appendChild(caixa);
      }
    }

    var erro = tipo === 'erro';
    caixa.classList.toggle('is-erro', erro);
    caixa.classList.toggle('is-ok', !erro);

    caixa.innerHTML =
      '<svg viewBox="0 0 18 18" width="16" height="16" fill="none" ' +
      'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" ' +
      'stroke-linejoin="round" aria-hidden="true">' +
      (erro ? ICONE_ERRO : ICONE_OK) +
      '</svg>';

    /* O texto vem do tema; entra como texto, nunca como markup. */
    var span = document.createElement('span');
    span.textContent = texto;
    caixa.appendChild(span);

    /* Reinicia a animação quando a mensagem troca sem sair da tela. */
    caixa.classList.remove('is-visivel');
    void caixa.offsetWidth;
    caixa.classList.add('is-visivel');

    clearTimeout(caixa.temporizador);
    caixa.temporizador = setTimeout(function () {
      esconder(caixa);
    }, SUMIR_APOS);
  }

  function esconder(caixa) {
    if (!caixa) return;
    clearTimeout(caixa.temporizador);
    caixa.classList.remove('is-visivel');
    caixa.addEventListener('transitionend', function fim() {
      caixa.removeEventListener('transitionend', fim);
      if (!caixa.classList.contains('is-visivel')) caixa.remove();
    });
  }

  /* Digitou de novo: o aviso anterior perdeu a validade. Delegado no
     documento porque o input é trocado a cada re-renderização. */
  document.addEventListener('input', function (evento) {
    var campo = evento.target.closest('.drgut-coupon__input');
    if (!campo) return;
    var raiz = campo.closest('minicart-discount');
    if (raiz) esconder(raiz.querySelector('.drgut-coupon__msg'));
  });

  customElements.whenDefined('minicart-discount').then(function () {
    var proto = customElements.get('minicart-discount').prototype;

    proto.toastSuccess = function (texto) {
      mostrar(this, texto, 'ok');
    };
    proto.toastError = function (texto) {
      mostrar(this, texto, 'erro');
    };
  });
})();
